/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const enum Header {
  ACCEPT = 'accept',
  ACCEPT_ENCODING = 'accept-encoding',
  ACCESS_CONTROL_ALLOW_HEADERS = 'access-control-allow-headers',
  ACCESS_CONTROL_ALLOW_METHODS = 'access-control-allow-methods',
  ACCESS_CONTROL_ALLOW_ORIGIN = 'access-control-allow-origin',
  ACCESS_CONTROL_MAX_AGE = 'access-control-max-age',

  AUTHORIZATION = 'authorization',
  CACHE_CONTROL = 'cache-control',
  CONNECTION = 'connection',
  CONTENT_ENCODING = 'content-encoding',
  CONTENT_TYPE = 'content-type',
  COOKIE = 'cookie',
  EXPIRES = 'expires',
  HOST = 'host',
  LOCATION = 'location',
  PRAGMA = 'pragma',
  REFERER = 'referer',

  // This is the header we will add to IAM refresh token requests to correlate
  // the client's request with the IAM request.
  TRANSACTION_ID = 'transaction-id',

  // Set by Akamai and used to request IAM tokens
  TRUE_CLIENT_IP = 'true-client-ip',

  USER_AGENT = 'user-agent',

  // Header to notify a downstream NGINX proxy to not buffer the response
  // See https://www.nginx.com/resources/wiki/start/topics/examples/x-accel/#x-accel-buffering
  X_ACCEL_BUFFERING = 'x-accel-buffering',

  // Used to specify the server-generated CSRF token to protect sensitive
  // API calls against CSRF attacks.
  X_CSRF_TOKEN = 'x-csrf-token',

  X_GLOBAL_TRANSACTION_ID = 'x-global-transaction-id',
  X_REQUEST_DURATION = 'x-request-duration',
  X_REQUEST_ID = 'x-request-id',
  X_REQUEST_START = 'x-request-start-time-ms',
  X_WATSON_CONVERSATION_TOOLING = 'x-watson-conversation-tooling',
  X_WATSON_DISCOVERY_NEXT = 'x-watson-discovery-next',
  X_WATSON_MCSP_JWT = 'x-watson-mcsp-jwt',
  X_WATSON_ORIGIN = 'x-watson-origin',
  X_WATSON_TOOLING_IDENTITY = 'x-watson-tooling-identity',
  X_WATSON_UI_INFO = 'x-watson-ui-info',
  X_WATSON_USERINFO = 'x-watson-userinfo',
  WWW_AUTHENTICATE = 'www-authenticate'
}
